import Settings from "../settings";

/**
 * Enum for Log types
 * @typedef {string} LogType
 * @readonly
 * @enum {string}
 * @property {string} Error "error"
 * @property {string} Info "info"
 * @property {string} Warn "warn"
 */
export enum LogType {
    Error = "error",
    Info = "info",
    Warn = "warn",
}

class LogMessage {
    public date: Date;
    public type: LogType;
    public message: any[];

    constructor(type: LogType, message: any[]) {
        this.date = new Date();
        this.type = type;
        this.message = message;
    }
}

export class Log {
    /** If set to true, each log entry will include a console output */
    public static debug: boolean = Settings.OutputLog;

    public static error(...args: any[]) {
        Log.entry(LogType.Error, args);
    }

    public static info(...args: any[]) {
        Log.entry(LogType.Info, args);
    }

    public static warn(...args: any[]) {
        Log.entry(LogType.Warn, args);
    }

    public static show(size?: number) {
        if (size === undefined || size <= 0)
            size = Log._log.length;

        let i;
        const max = size;

        for (i = 0; i < max; i += 1) {
            const l = Log._log[i];
            if (console && typeof console[l.type] === "function") {
                // push date stamp in front of message
                const dateStamp: string = Log.makeDateStamp(l.date);
                l.message.splice(0, 0, dateStamp);
                console[l.type].apply(console, l.message);
            }

        }
    }

    /** The internal array holding messages */
    private static _log: LogMessage[] = [];

    /**
     * The maximum number of log messages to hold
     * @default 500
     */
    private static _maxSize: number = 500;

    private static entry(type: LogType, msgArray: any[]) {
        // Make sure the log does not become bigger than _maxSize
        if (Log._log.length > Log._maxSize)
            Log._log = Log._log.splice(0, Log._maxSize);

        let i: number = 0;
        const _msgArray: any[] = [];
        const len: number = msgArray.length;

        if (len) {
            for (i; i < len; i += 1)
                _msgArray.push(msgArray[i]);

            // prepend message at beginning of log array
            Log._log.splice(0, 0, new LogMessage(type, _msgArray));
        }

        // optionally output the message if debug is enabled
        if (Log.debug && console && typeof console[type] === "function") {
            // push date stamp in front of message
            const dateStamp = Log.makeDateStamp();
            msgArray.splice(0, 0, dateStamp);
            console[type].apply(console, msgArray);
        }
    }

    /**
     * Returns a date/time stamp in the format of "MM/dd/yyyy HH:mm:ss"
     * @param {Date} [date = new Date()] The date from which to make a date/time stamp from
     * @returns {string} A date/time stamp of the supplied date
     */
    private static makeDateStamp(date: Date = new Date()) {
        return date.getUTCFullYear() + "/" +
            ("0" + (date.getUTCMonth() + 1)).slice(-2) + "/" +
            ("0" + date.getUTCDate()).slice(-2) + " " +
            ("0" + date.getUTCHours()).slice(-2) + ":" +
            ("0" + date.getUTCMinutes()).slice(-2) + ":" +
            ("0" + date.getUTCSeconds()).slice(-2);
    }

    constructor() {
        throw new Error("Cannot \"new\" the Log class.");
    }
}



// WEBPACK FOOTER //
// ./src/utils/Log.ts